import { AREA_ACTION_TYPES } from '../../actions/area/area_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const areas = (state = initialState, action) => {
    switch (action.type) {
        case AREA_ACTION_TYPES.GET_AREAS_SUCCESS:
            return { ...state, collection: action.payload };
        case AREA_ACTION_TYPES.POST_AREA_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case AREA_ACTION_TYPES.PUT_AREA_SUCCESS:
            const updatedArea = action.payload;
            return { ...state, collection: state.collection.map((area) => area.uuid !== updatedArea.uuid ? area : { ...area, ...updatedArea }) };
        case AREA_ACTION_TYPES.UPDATE_AREAS_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
